import React from 'react'

function BoxWrapper({children}) {
  return (
    <div class="bg-[#f4f5f7] min-h-screen">
    <div className="flex justify-center items-center max-w-screen-xl pb-20 mx-auto">
      <div className="bg-white shadow-lg rounded-lg border-solid border-t-4 border-[#38BFD8]  w-full mt-12 px-10 py-4">
          <div className="flex justify-between">
          <div className="p-4 w-full">
                {children}
          </div>
          </div>
      </div>
    </div>
  </div>
  )
}

export default BoxWrapper